module.exports = __webpack_public_path__ + "static/media/carrot.537bdb50.svg";